export const VIEWBOX_WIDTH = 1200;
export const VIEWBOX_HEIGHT = 720;
export const SCALE_LANES = 8;
export const LOOP_BARS = 4;
export const BEATS_PER_BAR = 4;
export const LOOP_LENGTH_BEATS = LOOP_BARS * BEATS_PER_BAR;
export const QUANTIZATION_STEP = 0.5; // eighth-note grid
export const MAX_LAYERS = 3;
export const MAX_EVENTS_PER_LAYER = 96;
export const NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
export const BASE_MIDI_NOTE = 60; // middle C

export const SCALES = [
  // Center lanes: mid register; edges: tasteful low/high. All notes are C pentatonic over octaves.
  // L→R:   E3  A3  C4  D4  E4  G4  A4  C5
  { id: 'pentatonic', labelKey: 'scales.pentatonic', steps: [-8, -3, 0, 2, 4, 7, 9, 12] },
];
